export const getMatchFormat = (key) => {
  switch (key) {
    case 'odi':
      return 'ODI'
    case 'lista':
      return 'List A'
    case 't20i':
      return 'T20I'
    default:
      return key
  }
}
